module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av566-b6100bd6c7a655d56f4ef9db50a9370a.jpg";